import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail,
  updateProfile,
  User as FirebaseUser,
  confirmPasswordReset as firebaseConfirmPasswordReset // Importa confirmPasswordReset
} from 'firebase/auth';
import { auth } from '../../config/firebase';
import { User } from '../../types';
import { translateAuthError } from '../../utils/authErrorTranslator';

export const registerUser = async (email: string, password: string, name: string): Promise<User> => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(userCredential.user, { displayName: name });

    return {
      id: userCredential.user.uid,
      email: userCredential.user.email!,
      name: name,
      isAnonymous: false
    };
  } catch (error: any) {
    throw new Error(translateAuthError(error));
  }
};

export const loginUser = async (email: string, password: string): Promise<User> => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return {
      id: userCredential.user.uid,
      email: userCredential.user.email!,
      name: userCredential.user.displayName || '',
      isAnonymous: false
    };
  } catch (error: any) {
    throw new Error(translateAuthError(error));
  }
};

export const logoutUser = async (): Promise<void> => {
  try {
    await signOut(auth);
  } catch (error: any) {
    throw new Error(translateAuthError(error));
  }
};

export const sendPasswordResetEmail = async (email: string): Promise<void> => {
  try {
    await firebaseSendPasswordResetEmail(auth, email);
  } catch (error: any) {
    throw new Error(translateAuthError(error));
  }
};

// Nova função confirmPasswordReset
export const confirmPasswordReset = async (token: string, newPassword: string): Promise<void> => {
  try {
    await firebaseConfirmPasswordReset(auth, token, newPassword);
  } catch (error: any) {
    throw new Error(translateAuthError(error));
  }
};

export const firebaseUserToUser = (firebaseUser: FirebaseUser): User => {
  return {
    id: firebaseUser.uid,
    email: firebaseUser.email!,
    name: firebaseUser.displayName || '',
    isAnonymous: firebaseUser.isAnonymous
  };
};
